import reduceColorPointByRatio from '../../../common/utils/reduce-color-point-by-ratio';

const dark = (params) => {
  const { backgroundColor, errorColorPalette } = params;
  const fallback = {
    rule: 'input.errorMessage.dark',
    params,
  };

  return reduceColorPointByRatio(
    {
      targetColor: errorColorPalette[900],
      targetColorPalette: errorColorPalette,
      backgroundColor,
      condition: (ratio) => ratio >= 4.5,
      fallback,
    },
    '900'
  );
};

export default dark;
